import QR from 'qrcode-base64';
import { priceFormat } from '../../utils';
import { escapeHtml } from './shopUtils';

const RECEIPT_STYLE = [
    '.schoolLogo{width:30%;height:20%}.logoLine{display:flex}.dateLogoContainer{margin-left:5%}',
    '.rowContainer{display:flex;width:100%}.row-class{width:20%;padding:0.5em 1em}',
    '.row-studentcode{width:30%;padding:0.5em 1em}.row-studentname{width:40%;padding:0.5em 1em;flex-wrap:wrap;word-wrap:break-word}',
    '.row-food{width:30%;padding:0.5em 1em}.row-foodNumber{width:20%;padding:0.5em 1em}',
    '.row-foodPrice{width:20%;padding:0.5em 1em}.row-foodTotal{width:30%;padding:0.5em 1em}',
    '.row-total{width:40%;padding:0.5em 1em;font-weight:bold}.row-totalNumber{width:30%;padding:0.5em 1em;font-weight:bold}',
    '.row-totalPrice{display:flex;justify-content:flex-end;font-weight:bold;padding:0.5em 1em}',
    '@media print{@page{margin:0}body{margin:0cm}}',
].join('');

function writeReceiptBlock(win, params, currentUser) {
    const { productList, userObj, ebarimtResult, paymentType, cardInfo,
        prodAmount, totalQuantity, fontSize, date, showQr, headerMargin } = params;

    win.document.write(`<div style="display:flex;margin:${headerMargin || '0px'};">`);
    win.document.write(
        `<div style="font-size:${fontSize}px;word-break:break-all;text-transform:uppercase;">` +
        escapeHtml(currentUser?.schoolName) + '</div>'
    );
    win.document.write('</div>');

    if (currentUser?.schoolContact) {
        win.document.write('<div style="display:flex;margin:0px;">');
        win.document.write(
            `<div style="font-size:${fontSize}px;word-break:break-all;text-transform:uppercase;">` +
            'Утас:' + escapeHtml(currentUser?.schoolContact) + '</div>'
        );
        win.document.write('</div>');
    }

    win.document.write('<div style="display:flex;margin:0px;">');
    win.document.write(
        `<div style="font-size:${fontSize}px;word-break:break-all;text-transform:uppercase;">` +
        'Хэвлэсэн:' + escapeHtml(currentUser?.person?.firstName) + '</div>'
    );
    win.document.write('</div>');

    win.document.write(
        `<p style="margin:10px 0;font-size:${fontSize}px;">` +
        `${userObj?.title ? escapeHtml(userObj.title) + ',' : ''} ` +
        `${userObj?.code ? escapeHtml(userObj.code) + ',' : ''} ` +
        `${userObj?.firstName ? escapeHtml(userObj.firstName) : ''}` +
        '</p>'
    );

    for (const prodObj of productList) {
        win.document.write('<div style="display:flex;">');
        win.document.write(`<p style="width:50%;margin:0px;font-size:${fontSize}px;display:inline-block;">` + escapeHtml(prodObj.productName) + '</p>');
        win.document.write(`<p style="width:10%;margin:0px;display:inline-block;font-size:${fontSize}px;">` + parseInt(prodObj.quantity) + '</p>');
        win.document.write(`<p style="width:20%;margin:0px;display:inline-block;font-size:${fontSize}px;">` + priceFormat(parseInt(prodObj.price)) + '</p>');
        win.document.write(`<p style="display:inline-block;margin:0px;font-size:${fontSize}px;">` + priceFormat(parseInt(prodObj.amount)) + '</p>');
        win.document.write('</div>');
    }

    win.document.write('<hr style="margin:0px;border-top:1px solid;">');
    win.document.write('<div>');
    win.document.write(`<p style="width:50%;margin:0px;display:inline-block;font-weight:bold;font-size:${fontSize}px;">Нийт дүн</p>`);
    win.document.write(`<p style="width:30%;margin:0px;display:inline-block;font-weight:bold;font-size:${fontSize}px;">` + totalQuantity + '</p>');
    win.document.write(`<p style="display:inline-block;margin:0px;position:absolute;font-weight:bold;font-size:${fontSize}px;">` + priceFormat(prodAmount) + '</p>');
    win.document.write('</div>');

    if (paymentType) {
        const label = paymentType === 'BANK_CARD' ? 'Банкны картаар' : (paymentType === 'ESCHOOL_CARD' ? 'Үнэмлэхээр' : '');
        win.document.write('<div>');
        win.document.write(`<p style="width:100%;margin:10px 0px;display:inline-block;font-size:${fontSize}px;">Төлсөн хэлбэр: ${label}</p>`);
        win.document.write('</div>');
    }

    if (userObj?.balance) {
        win.document.write('<div>');
        win.document.write(`<p style="width:100%;margin:0px;display:inline-block;font-size:${fontSize}px;">Өмнөх үлдэгдэл: ` + priceFormat(userObj.balance + prodAmount) + '</p>');
        win.document.write('</div>');
        win.document.write('<div>');
        win.document.write(`<p style="width:100%;margin:0px;display:inline-block;font-size:${fontSize}px;">Картын үлдэгдэл: ` + priceFormat(userObj.balance) + '</p>');
        win.document.write('</div>');
    }

    if (ebarimtResult) {
        if (showQr) {
            const imgData = QR.drawImg(ebarimtResult?.qrData, { typeNumber: 1, errorCorrectLevel: 'L', size: 150 });
            win.document.write('<div style="margin-top:5px;">');
            win.document.write(`<p style="width:50%;margin:0px;display:inline-block;font-weight:bold;font-size:${fontSize}px;">Сугалаа</p>`);
            win.document.write(`<p style="width:50%;display:inline-block;margin:0px;font-weight:bold;position:absolute;font-size:${fontSize}px;text-align:right;">` + escapeHtml(ebarimtResult?.lottery) + '</p>');
            win.document.write('</div>');
            win.document.write('<div>');
            win.document.write(`<p style="width:50%;margin:0px;display:inline-block;font-weight:bold;font-size:${fontSize}px;">EBarimt дүн</p>`);
            win.document.write(`<p style="width:50%;display:inline-block;margin:0px;font-weight:bold;position:absolute;font-size:${fontSize}px;text-align:right;">` + escapeHtml(ebarimtResult?.amount) + '</p>');
            win.document.write('</div>');
            win.document.write('<hr style="margin:5px;border-top:0.5px solid;">');
            win.document.write('<div style="text-align:center;">');
            win.document.write('<img src="' + imgData + '" style="width:150px;margin:auto;"/>');
            win.document.write('</div>');
        }
        win.document.write('<div style="margin-top:5px;">');
        win.document.write(`<p style="width:50%;margin:0px;display:inline-block;font-weight:bold;font-size:${fontSize}px;">НӨАТ</p>`);
        win.document.write(`<p style="width:50%;display:inline-block;margin:0px;font-weight:bold;position:absolute;font-size:${fontSize}px;text-align:right;">` + escapeHtml(ebarimtResult?.vat) + '</p>');
        win.document.write('</div>');
        win.document.write('<div>');
        win.document.write(`<p style="width:100%;margin:0px;display:inline-block;font-size:${fontSize}px;">ДДТД:  ` + escapeHtml(ebarimtResult?.billId) + '</p>');
        win.document.write('</div>');
    }

    if (cardInfo) {
        win.document.write('<div>');
        win.document.write(`<p style="width:100%;margin:0px;display:inline-block;font-size:${fontSize}px;">Картын дугаар: ` + escapeHtml(cardInfo) + '</p>');
        win.document.write('</div>');
    }

    win.document.write('<div>');
    win.document.write(`<p style="display:flex;font-size:${fontSize}px;margin:10px 0px;justify-content:center;">` + escapeHtml(date) + '</p>');
    win.document.write('</div>');
}

export function printProducts(productList = [], userObj = {}, date = '', ebarimtResult = null,
    schoolCopy = false, paymentType = null, cardInfo = null, fontSize = 10, currentUser = {}) {

    let prodAmount = 0;
    let totalQuantity = 0;
    for (const prodObj of productList) {
        prodAmount += parseInt(prodObj.amount);
        totalQuantity += parseInt(prodObj.quantity);
    }

    const blockParams = { productList, userObj, ebarimtResult, paymentType, cardInfo, prodAmount, totalQuantity, fontSize, date };

    const win = window.open('', '_blank');
    if (!win) return;

    win.document.write(`<html style="margin:0;padding:0;"><head><style>${RECEIPT_STYLE}</style></head><body style="margin:0px;">`);
    writeReceiptBlock(win, { ...blockParams, showQr: true, headerMargin: '0px' }, currentUser);
    if (schoolCopy) {
        writeReceiptBlock(win, { ...blockParams, showQr: false, headerMargin: '30px 0px 0px 0px' }, currentUser);
    }
    win.document.write('</body></html>');
    win.document.body.style.fontFamily = 'Pinnacle, Arial, sans-serif';
    win.document.close();

    const doPrint = () => {
        const images = win.document.images;
        if (images.length === 0) {
            win.focus();
            win.print();
            win.onafterprint = () => win.close();
            setTimeout(() => { if (!win.closed) win.close(); }, 2000);
            return;
        }
        let loaded = 0;
        const onImageLoad = () => {
            loaded++;
            if (loaded === images.length) {
                win.focus();
                win.print();
                win.onafterprint = () => win.close();
                setTimeout(() => { if (!win.closed) win.close(); }, 2000);
            }
        };
        for (let i = 0; i < images.length; i++) {
            if (images[i].complete) {
                onImageLoad();
            } else {
                images[i].onload = onImageLoad;
                images[i].onerror = onImageLoad;
            }
        }
    };

    if (win.document.readyState === 'complete') {
        doPrint();
    } else {
        win.onload = doPrint;
    }
}
